module.exports = __webpack_public_path__ + "img/order_year_bg.57a64e2b.png";